"use client";
import { QueryClientProvider, Hydrate } from '@blitzjs/rpc';
import React__default from 'react';

const BlitzProvider = ({
  client = globalThis.queryClient,
  contextSharing = false,
  dehydratedState,
  hydrateOptions,
  children
}) => {
  if (client) {
    return /* @__PURE__ */ React__default.createElement(QueryClientProvider, {
      client: client || globalThis.queryClient,
      contextSharing
    }, /* @__PURE__ */ React__default.createElement(Hydrate, {
      state: dehydratedState,
      options: hydrateOptions
    }, children));
  }
  return children;
};

export { BlitzProvider };
